import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestStatus } from 'legacy/lut/configs/service'

import { PARTNER360_PBM_COCKPIT_NAMESPACE } from '../constants'

import type { IPbmCockpitState, PbmCockpitData } from './types'

const initialState: IPbmCockpitState = {
  planningCycles: [],
  partners: [],
  finData: [],
  fetchingStatus: RequestStatus.NONE,
  error: null,
}

const pbmCockpitSlice = createSlice({
  name: PARTNER360_PBM_COCKPIT_NAMESPACE,
  initialState,
  reducers: {
    syncPbmCockpitFromFinancialPending(state) {
      state.fetchingStatus = RequestStatus.PENDING
      state.error = null
    },
    syncPbmCockpitFromFinancialRejected(state, action: PayloadAction<string | undefined>) {
      state.fetchingStatus = RequestStatus.REJECTED
      state.error = action.payload ?? 'Failed to fetch PBM cockpit data'
    },
    syncPbmCockpitFromFinancialFulfilled(state, action: PayloadAction<PbmCockpitData>) {
      state.fetchingStatus = RequestStatus.FULFILLED
      state.planningCycles = action.payload.planningCycles
      state.partners = action.payload.partners
      state.finData = action.payload.finData
      state.error = null
    },
  },
})

export const {
  syncPbmCockpitFromFinancialPending,
  syncPbmCockpitFromFinancialRejected,
  syncPbmCockpitFromFinancialFulfilled,
} = pbmCockpitSlice.actions

export const pbmCockpitSliceReducer = pbmCockpitSlice.reducer
